<template>
  <aside class="sidebar" :class="{ 'sidebar-open': sidebarOpen }">
    <div class="sidebar-header">
      <h3>对话历史</h3>
    </div>
    <div class="conversation-list">
      <div
        v-for="(conv, index) in conversations"
        :key="index"
        class="conversation-item"
        :class="{ active: currentConvIndex === index }"
        @click="$emit('switch-conversation', index)"
      >
        <div class="conv-icon">💬</div>
        <div class="conv-info">
          <div class="conv-title">{{ conv.title }}</div>
          <div class="conv-time">{{ conv.time }}</div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ChatSidebar',
  props: {
    conversations: {
      type: Array,
      default: () => []
    },
    currentConvIndex: {
      type: Number,
      default: 0
    },
    sidebarOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}
.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
}
.sidebar-header h3 {
  margin: 0;
  font-size: 16px;
  color: #1a1a2e;
}
.conversation-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.conversation-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;
}
.conversation-item:hover {
  background: #f5f7fa;
}
.conversation-item.active {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  border-left: 3px solid #667eea;
}
.conv-icon {
  font-size: 20px;
}
.conv-info {
  flex: 1;
  overflow: hidden;
}
.conv-title {
  font-size: 14px;
  color: #1a1a2e;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.conv-time {
  font-size: 12px;
  color: #999;
}
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 200;
    transform: translateX(-100%);
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }
  .sidebar-open {
    transform: translateX(0);
  }
}
</style>
